import { createAction } from 'typesafe-actions';
import { ACTIONS, Notices } from './types';

export const addNoticeAction = createAction(ACTIONS.ADD_NOTICE)<{ notification: Notices }>();

export const removeNoticeAction = createAction(ACTIONS.REMOVE_NOTICE)();
